var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h4',{staticClass:"panel-title"},[_vm._v("Thông tin ví")]),_c('hr'),_c('div',{staticClass:"wallet-box"},[_c('table',[_c('tr',[_c('td',[_vm._v("Số dư tài khoản:")]),_c('td',{staticClass:"fb"},[_vm._v(_vm._s(_vm._f("formatNumber")((_vm.customerInfo.Wallet || 0),'0,0')))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }